class IncognitoModeError extends Error {
  constructor(cause) {
    super('IncognitoModeError', { cause });
    this.name = 'IncognitoModeError';
  }
}

export default IncognitoModeError;
